// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"445":"1bfc9850","532":"styles","678":"component---src-pages-index-js","774":"framework","883":"component---src-pages-404-js"}[chunkId] + "-" + {"445":"3ac51c6fcc32dbb4b884","532":"03562a72e9acc1b67a5d","678":"d28794ec7a7154f4155b","774":"9ecb2a204555dda27745","883":"740e883b6bb6e49c7358"}[chunkId] + ".js";
};